export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 lg:py-28 bg-[#FFFFFF]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="text-center mb-10 reveal">
          <div className="text-[0.6rem] uppercase tracking-[0.32em] mb-3" style={{ color: "#B89968" }}>
            Stacy Fox · Founder
          </div>
          <h2
            className="font-serif font-light leading-[0.95]"
            style={{ color: "#161618", fontSize: "clamp(2.5rem, 6vw, 4.75rem)", letterSpacing: "0.02em" }}
          >
            Meet Stacy
          </h2>
          <div
            className="mt-5 font-serif italic"
            style={{ color: "#B89968", fontSize: "clamp(1.25rem, 2.4vw, 1.85rem)" }}
          >
            Natural results, anatomy led.
          </div>
          <div className="flex items-center justify-center gap-3 mt-6">
            <span className="h-px w-12" style={{ background: "#B89968" }} />
            <span className="text-xs" style={{ color: "#B89968" }}>♥</span>
            <span className="h-px w-12" style={{ background: "#B89968" }} />
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-5 reveal">
          <div className="overline text-[0.65rem] uppercase tracking-[0.3em] text-[#8C8580] mb-6">
            ◦ 01 — The Practitioner
          </div>
          <h2 className="font-serif font-light text-5xl sm:text-6xl leading-[1] text-[#161618]">
            Meet <span className="italic text-[#B6AA96]">Stacy</span>.
          </h2>
          <div className="mt-10 space-y-5 text-[#4D4A47] font-light text-base sm:text-[1.05rem] leading-relaxed">
            <p>
              Hi, I&apos;m Stacy, advanced aesthetics practitioner and founder
              of Stacy Fox Laser &amp; Aesthetics.
            </p>
            <p>
              My approach to aesthetics is simple.. natural results, grounded
              in anatomy, delivered safely and honestly. I specialise in
              anti-wrinkle treatments, dermal fillers, skin rejuvenation, laser
              and regenerative treatments. With a strong focus on facial
              structure, skin quality and long-term treatment planning.
            </p>
            <p>
              I believe great aesthetic work should never look obvious, unless
              it&apos;s right for you. Leaving you refreshed and balanced and
              feeling like you on your very best day.
            </p>
            <p>
              Every face is different, which is why I take an anatomy-led
              approach to treatment. Rather than chasing trends or overfilling
              I assess facial proportions, retaining ligaments, volume loss
              patterns, muscle movement and skin health to create results that
              are refined and harmonious from every angle.
            </p>
            <p>
              My clinics are built on education, safety and trust. I&apos;ll
              always explain the &ldquo;why&rdquo; behind a treatment, advise
              honestly and prioritise what is appropriate for your face even
              if that means recommending less treatments, not more.
            </p>
            <p>
              Alongside injectables I&apos;m passionate about skin health and
              collagen stimulation. Healthy skin is the foundation of every
              beautiful result. Which is why treatments such as microneedling,
              microneedling with RF, PRP and skin boosters play a key role in
              many of my treatment plans.
            </p>
            <p>
              Whether you&apos;re new to aesthetics or looking for a
              practitioner who values subtlety and structure over trends,
              you&apos;ll be treated with care, professionalism and a tailored
              approach from consultation through to review.
            </p>
            <p className="font-serif italic text-xl text-[#161618] pt-2">
              Because good aesthetics shouldn&apos;t change who you are, they
              should quietly elevate what&apos;s already there.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-8 border-t border-[#C9BEA9] pt-8">
            <Credential title="Registered" detail="GDC" />
            <Credential title="Certified" detail="Advanced Injectables" />
            <Credential title="Clinic" detail="Private, by appointment" />
          </div>
        </div>

        <div className="lg:col-span-7 reveal reveal-zoom">
          <div className="relative">
            <div className="aspect-[5/6] border border-[#C9BEA9] overflow-hidden bg-[#E6DFCC]">
              <img
                src="https://customer-assets.emergentagent.com/job_beauty-templates/artifacts/q6u6uhq7_IMG_3043.jpeg"
                alt="Stacy Fox — founder & lead practitioner"
                className="w-full h-full object-cover"
                data-testid="about-stacy-portrait"
              />
            </div>
            <div className="absolute -top-10 -right-6 hidden md:block">
              <blockquote className="bg-[#161618] text-[#F1EDDE] p-8 max-w-xs font-serif italic text-xl leading-snug">
                &ldquo;Subtle beauty. The best compliment is — &apos;you look
                well-rested&apos;.&rdquo;
                <div className="mt-4 text-[0.65rem] uppercase tracking-[0.25em] not-italic font-sans font-medium text-[#B6AA96]">
                  — Stacy Fox
                </div>
              </blockquote>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

const Credential = ({ title, detail }) => (
  <div>
    <div className="text-[0.65rem] uppercase tracking-[0.25em] text-[#8C8580]">
      {title}
    </div>
    <div className="font-serif text-2xl text-[#161618] mt-2">{detail}</div>
  </div>
);

export default About;
